import {
  email_repository,
} from '@/repositories';

const state = () => ({
  email_signature_list: [], // for logged user
  email_signature_list_of_all_users: [],
});

const getters = {
  email_signature_list_of_all_users: (state) => state.email_signature_list_of_all_users,
  emailSignatureList: (state) => state.email_signature_list,
  signaturedUserIdList: (state) => state.email_signature_list_of_all_users.length > 0
    ? state.email_signature_list_of_all_users.map((signature)=> signature.user_id)
    : [],
};

const actions = {
  async getEmailSignatureListOfAllUsers({ commit }, data) {
    const signature_list = await email_repository.getSignaturesOfOtherUsers(data);

    commit('set_email_signature_list_of_all_users', signature_list);

    return signature_list;
  },
  async getEmailSignature({ commit }, data) {
    const result = await email_repository.getEmailSignature(data);

    commit('set_email_signature_list', result.signature_list);

    return result.signature_list;
  },

  async createEmailSignature(_, data) {
    const result = await email_repository.createEmailSignature(data);

    return result.data;
  },

  async updateEmailSignature(_, data) {
    const result = await email_repository.updateEmailSignature(data);

    return result.data;
  },

  async deleteSignature(_, signature_id) {
    const response = await email_repository.deleteSignature(signature_id);

    return response;
  },
};

const mutations = {
  set_email_signature_list(state, email_signature_list) {
    state.email_signature_list = email_signature_list;
  },
  set_email_signature_list_of_all_users(state, email_signature_list_of_all_users) {
    state.email_signature_list_of_all_users = email_signature_list_of_all_users;
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
